/** style setting */
// default background style
export const defaultBackgroundStyle = "light";

// dark style for societyNetwork
export const backgroundDarkStyle = {
  display: "flex",
  justifyContent: "center",
  // margin: "10px",
  // padding: "10px",
  backgroundColor: "black",
  height: "100%",
};

// light style for societyNetwork
export const backgroundLightStyle = {
  display: "flex",
  justifyContent: "center",
  // margin: "10px",
  // padding: "10px",
  backgroundColor: "white",
  // border: "1px solid #b3b3b3",
  height: "100%",
};

export const colorRangeDefault = [
  "#ff5252",
  "#ff814a",
  "#ffb629",
  "#fce262",
  "#b3e364",
  "#56d681",
  "#25dae0",
  "#3bbff0",
  "#459bff",
  "#9280ff",
  "#bb81ff",
  "#ff7ce1",
];

export const nodeCommonStyle = {
  nodeSize: {
    min: 5,
    max: 12,
  },
  opacityDefault: 1,
  opacityHighlight: 1,
  opacityDisHighlight: 0.5,
  fillColorDisHighlight: "#eee",
  nodeCursor: {
    type: "grab",
  },
  mouseEvent: {
    click: "on",
    mouseover: "on",
    mouseout: "on",
  },
};

export const nodeDarkStyle = {
  strokeColor: "#fff",
  shadowColor: "grey",
  label: {
    color: "#fff",
  },
};

export const nodeLightStyle = {
  strokeColor: "#383838",
  shadowColor: "#fff",
  label: {
    color: "#383838",
  },
};

export const linkCommonStyle = {
  linkCursor: {
    type: "grab",
  },
  mouseEvent: {
    mouseover: "off",
    mouseout: "off",
  },
};

export const linkDarkStyle = {
  color: {
    min: "white",
    max: "red",
  },
};

export const linkLightStyle = {
  color: {
    min: "#ffbeb3",
    max: "red",
  },
};

export const subGroupCssStyle = {
  color: [
    // BLUE
    "#0074D9",
    // GREEN
    "#2ECC40",
    // FUCHSIA
    "#F012BE",
    // TEAL
    "#39CCCC",
    // GRAY
    "#AAAAAA",
    // ORANGE
    "#FF851B",
    // PURPLE
    "#B10DC9",
    // RED
    "#FF4136",
    // NAVY
    "#001f3f",
    // LIME
    "#01FF70",
    // OLIVE
    "#3D9970",
    // AQUA
    "#7FDBFF",
  ],
};

export const factionCssStyle = {
  color: ["red", "green", "blue", "orange"],
};

export const relationCssStyle = {
  color: ["red", "green", "blue", "orange", "yellow"],
};

export const relationLocale = {
  noRelation: {
    en: "noRelation",
    zh: "無關係",
    order: 5, // order 用來排序 sidebar 親屬關係中的 label, 數字愈高排在愈前面
  },
  dingCuoInLaw: {
    en: "dingCuoInLaw",
    zh: "頂厝配偶與姻親",
    order: 4,
  },
  dingCuoKinship: {
    en: "dingCuoKinship",
    zh: "頂厝親屬",
    order: 3,
  },
  xiaCuoInLaw: {
    en: "xiaCuoInLaw",
    zh: "下厝配偶與姻親",
    order: 2,
  },
  xiaCuoKinship: {
    en: "xiaCuoKinship",
    zh: "下厝親屬",
    order: 1,
  },
};

// todo: 社團 id 與 label 對照
export const groupLocale = {
  GRP1: { id: "GRP1", label: "臺灣共產黨" },
  GRP2: { id: "GRP2", label: "臺灣地方自治聯盟" },
  GRP3: { id: "GRP3", label: "臺灣工友總聯盟" },
  GRP4: { id: "GRP4", label: "臺灣文化協會" },
  GRP5: { id: "GRP5", label: "臺灣民眾黨" },
  GRP6: { id: "GRP6", label: "臺灣農民組合" },
  GRP7: { id: "GRP7", label: "蘭陽農業組合" },
};

export const placeNodeConfig = {
  center: {
    name: "center",
    radius: 30,
  }, // all nodes centered
  edge: {
    name: "edge",
    radius: 800,
  }, // all nodes edged
  centerAndEdge: {
    name: "",
    smRadius: 0,
    lgRadius: 1500,
  }, // big nodes centered, and small nodes edged
};
